import { defineStore } from 'pinia';
import { adminApi, clearSessionTokens, getAccessToken, setSessionTokens } from '../api';
import type { AdminIdentity } from '../types';

export const useAdminAuthStore = defineStore('admin-auth', {
  state: () => ({
    admin: null as AdminIdentity | null,
    initialized: false,
    loading: false,
  }),
  getters: {
    authenticated: (state) => Boolean(state.admin),
    permissions: (state) => new Set(state.admin?.permissions || []),
    environment: () => import.meta.env.VITE_APP_ENV || 'development',
  },
  actions: {
    has(permission?: string) {
      return !permission || Boolean(this.admin?.permissions.includes(permission));
    },
    async initialize() {
      if (this.initialized) return;
      this.loading = true;
      try {
        if (getAccessToken() || localStorage.getItem('pengpeng-admin-csrf-token')) {
          const { admin } = await adminApi.session();
          this.admin = admin;
        }
      } catch {
        clearSessionTokens();
      } finally {
        this.loading = false;
        this.initialized = true;
      }
    },
    async login(username: string, password: string, remember: boolean) {
      const result = await adminApi.login({ username, password, remember });
      setSessionTokens(result.accessToken, result.csrfToken);
      this.admin = result.admin;
      this.initialized = true;
    },
    async logout() {
      try { await adminApi.logout(); } finally {
        clearSessionTokens();
        this.admin = null;
      }
    },
  },
});
